@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.edit-tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.name-input {
  width: 100%;
}

.color-picker {
  margin-left: 10px;
}

.x-button {
  cursor: pointer;
  height: 30px;
  width: 30px;
  position: relative;

  > svg {
    position: absolute;
    top: -5px;
    left: -5px;
    height: 40px;
    width: 40px;
    fill: @edit-tag-row--x-button--fill-color;
    transform: scale(0.26);
  }

  &:hover {
    > svg {
      fill: @edit-tag-row--x-button--hover--fill-color;
    }
  }
}
